/** @module Apparel/NewFilteredItem */
define([
    "dojo/_base/declare",
    "csi/table/AggregateFrom",
    "csi/xml/Query",
    "csi/xml/QueryFilterBuilder"
], function(declare,AggregateFrom,Query,QueryFilterBuilder) {

    return declare(AggregateFrom, {
        /**
         * @override
         * Apply query filters for the AggregateFrom action.
         */
        applyActionFilters: function(view) {
            var query = this._getQueryFilter(this._getQueryFilterInitialQuery());
            if (query) {
                view.relRoot.addQuery(query);
            }

            this.inherited(arguments);
        },

        /**
         * Get initial query.
         * @return {Query} The query.
         */
       _getQueryFilterInitialQuery: function() {
            return new Query();
        },

        /**
         * Filter query and add dependency paths for the query.
         * @param {Query} query - Query to be filtered and have paths added.
         * @return {Query} The filtered query.
         */
        _getQueryFilter: function(query) {
            var cache = this.getCache();
            var node = this.getParent();
            var queryFilterURL = node.QueryFilter;

            QueryFilterBuilder.create(query, queryFilterURL, node.$URL, cache);

            return query;
        }
    });
});